export default __webpack_public_path__ + "static/media/puppeteer.a21655dc.png";